import { Component, ViewChild, Output, EventEmitter, Input, OnInit } from '@angular/core';

import { GatewayServiceProvider, AlertService } from './../../../_services/services';

import { BookingPrepayModel } from "../../../_models/booking/booking-prepay.model";
import { Global } from 'src/app/globals';
import utils from 'src/app/utils';
import { SharedModule } from 'src/app/shared.module';
import { MaterialModule } from 'src/app/material.module';
import { AppSignaturePadComponent } from '../signature-pad/signature-pad.component';

@Component({
    selector: 'app-prepay',
    templateUrl: './prepay.component.html',
    imports: [
        SharedModule,
        MaterialModule
    ],
    standalone: true
})

export class PrepayComponent implements OnInit {

    @Output() cancelPrepay = new EventEmitter<any>();
    @Output() confirmPrepay = new EventEmitter<BookingPrepayModel>();
    @Output() confirmSplitPrepay = new EventEmitter<BookingPrepayModel>();
    @Input() prepayRemarks: BookingPrepayModel;
    @Input() qouteprepayRemarks: string;
    @Input() remarksCommenLimit: number = 300;
    @Input() quoteSignature: string;
    @Input() PendingSignatureRequiredStatus: boolean = false;
    @Input() showFarmAndFields: boolean;

    @ViewChild('signature')
    public signaturePad!: AppSignaturePadComponent;


    isSign: boolean = false;
    isSignatureRequired: boolean = false;
    maxIncidentDescriptionLength: number = 50;
    minDate: Date = new Date();

    public signatureImage: string;

    constructor(
        public globals: Global,
        private gatewayService: GatewayServiceProvider,
        public alertService: AlertService) {

        this.gatewayService.getAgentVersion((response) => {
            var version = parseInt(
                response.Version.replace(".", "").replace(".", "")
            );
            if (version < 1910) {
                this.maxIncidentDescriptionLength = 50;
            } else {
                this.maxIncidentDescriptionLength = this.remarksCommenLimit;
                if (this.prepayRemarks.prepayRemarks.length > this.remarksCommenLimit) {
                    this.prepayRemarks.prepayRemarks = this.prepayRemarks.prepayRemarks.substring(0, this.remarksCommenLimit);
                }
            }
        }, (error) => { })
    }

    ngOnInit(): void {

    }
    showImage() {
        this.prepayRemarks.signatureImage = this.signatureImage;
        this.isSignatureRequired = false;
    }


    ngAfterViewInit() {
        if (this.signaturePad) {
            this.signaturePad.clear();
        }
    }

    drawComplete(signatureDataUrl?: string) {
        const signatureImage = signatureDataUrl || this.signaturePad?.toDataUrl() || '';

        console.log('Completed drawing');
        console.log(signatureImage);
        if (this.isSignatureRequired) {
            if (!signatureImage || this.signaturePad.isEmpty()) {

                utils.confirmationDialog('Warning', "Signature is Required.", 'Close', (result) => {
                    if (result == 'Close') {
                        this.signatureImage = undefined;
                        this.signatureRequired();
                    }

                }, false);


            } else {
                let Signatureimage2: string = this.getSignaturePayload(signatureImage);
                console.log(Signatureimage2);
                this.signatureImage = signatureImage;
                this.prepayRemarks.signatureImage = Signatureimage2;

                this.showImage();
            }
        }
        else {
            let Signatureimage2: string = this.getSignaturePayload(signatureImage);
            console.log(Signatureimage2);
            this.signatureImage = signatureImage;
            this.prepayRemarks.signatureImage = Signatureimage2;

            this.showImage();
        }



    }
    drawStart() {
        console.log('Start drawing');
    }

    clear() {
        this.signaturePad.clear();
    }

    private getSignaturePayload(signatureImage: string): string {
        return signatureImage.replace(/^data:image\/png;base64,/, '');
    }


    ngAfterContentInit() {
        this.prepayRemarks.prepayRemarks = this.qouteprepayRemarks ? this.qouteprepayRemarks : '';
        if (this.quoteSignature) {
            this.isSign = true;
            this.signatureImage = this.quoteSignature;
        }


        this.signatureRequired();

    }



    signatureRequired() {

        if (this.PendingSignatureRequiredStatus && this.isSign == false && this.signatureImage == undefined) {
            this.isSignatureRequired = true;
            this.sign();

        } else if (this.PendingSignatureRequiredStatus && this.isSign == true && this.signatureImage != undefined) {
            this.isSignatureRequired = false;

        } else if (this.PendingSignatureRequiredStatus && this.isSign == true && this.signatureImage == undefined) {
            this.isSignatureRequired = true;

        } else if (this.PendingSignatureRequiredStatus == false) {
            this.isSignatureRequired = false;

        }


    }



    sign() {
        this.isSign = true;
    }
    resign() {
        this.signatureImage = undefined;
        this.signatureRequired();
    }
    cancel() {
        this.cancelPrepay.emit();
    }
    validateDates() {

        var endDateYear = new Date(Date.now()).getFullYear();
        var endDateMonth = new Date(Date.now()).getMonth();
        var endDateDate = new Date(Date.now()).getDate();
        var currentDate = new Date(endDateYear, endDateMonth, endDateDate);

        if (this.prepayRemarks.chequeDate < currentDate) {
            this.alertService.error("Invalid Check date", false, true);
            return false;
        }
        return true;
    }
    finishPrepay() {
        console.log('PostBooking - Prepay');
        this.prepayRemarks.mode = "Prepay";
        this.prepayRemarks.signatureImage = this.signatureImage;
        this.confirmPrepay.emit(this.prepayRemarks);
    }
    finishSplitPrepay() {
        console.log('PostBooking - Prepay');
        this.prepayRemarks.mode = "Prepay";
        this.prepayRemarks.signatureImage = this.signatureImage;
        this.confirmSplitPrepay.emit(this.prepayRemarks);
    }
    changeIsByPhone($event) {
        if (this.prepayRemarks.prepayRemarks.match(' -By Phone Call') == null) {
            $event.source.checked = true;
            if (this.maxIncidentDescriptionLength - this.prepayRemarks.prepayRemarks.length >= 16) {
                this.prepayRemarks.prepayRemarks = this.prepayRemarks.prepayRemarks + ' -By Phone Call';
                this.alertService.clear();
            }
            else {
                this.alertService.error("Please remove at least 16 characters to enable this feature.");
                $event.source.checked = false;
            }
        }
        else {
            this.prepayRemarks.prepayRemarks = this.prepayRemarks.prepayRemarks.replace(' -By Phone Call', '');
        }
    }
    numbersOnly(evt: KeyboardEvent) {
        if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
            evt.preventDefault();
        }
    }
}